var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBloginline = function SvgBloginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 2,
    y: 22,
    fill: "#00877C",
    rx: 2,
    transform: "rotate(-90 2 22)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.707 7.879 16.12 6.293a1 1 0 0 0-1.414 0l-1.352 1.353 3 3 1.352-1.353a1 1 0 0 0 0-1.414M12.646 8.354 7 14l-1 4 4-1 5.646-5.646z"
  })));
};
export default SvgBloginline;